module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.b1d8fb16.jpg";